// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"124":"rage-mode","450":"assistant-thinking","724":"skyline","952":"gold-coins"}[chunkId] || chunkId) + "." + {"124":"50b58624c31a95118d0f","437":"7ce4ef41c5234c083b03","450":"4647c55d175c6cb39d5f","724":"edd728f977c26c9f90d8","725":"c0fd414b9a239e9e3d2e","952":"16897f41159372018f06"}[chunkId] + ".chunk.js";
};